// extracted by mini-css-extract-plugin
module.exports = {"meal":"MenuItem_meal__2dRwY","description":"MenuItem_description__1dUu_","price":"MenuItem_price__wMVo1"};